export const SERVICE_CODE = 'ATTACHMENT' + '_SERVICE';
